import { createConsts } from '../../utils/redux/index';

const supportedActions = [
  // connection
  'CONNECTION_OPENED',
  'CONNECTION_READY',
  'SET_CONNECT_ERROR',
  'SET_CHAT_MODULE_INSTANCE',
  'DISCONNECT',
  // 'CLEAR',

  // chat api events
  'CONVERSATION_CHANGED',
  'RELOAD_HISTORY',

  // selectors
  'SET_LAST_CHANNEL_ID',
  'SET_AVAILABLE_CHANNELS',
  'UPDATE_AVAILABLE_CHANNELS',
  'SET_ACTIVE_CHANNEL_ID',
  'ADD_NEW_SUBCHANNEL',
  'UPDATE_CHANNEL_SUBCHANNELS',
  'SELECT_SOCIAL_CHAT',
  'SOCIAL_CHAT_INIT_SELECTION',

  // helpers
  'FETCH_MESSAGES',
  'CHECK_NEW_NOTIFICATIONS',
  'SET_CHANNEL_DATA',

  // actions
  'ADD_ACTIVE_UNREAD',
  'REMOVE_ACTIVE_UNREAD',
  'BUMP_ACTIVITY',
  'LOAD_NEXT_HISTORY_PAGE',
  'SEND_MESSAGE',
  'SEND_MESSAGE_WITH_INBOX_TASK',
  // uploads
  'UPLOAD_ATTACHMENT',
  'UPDATE_ATTACHMENT_UPLOAD_STATUS',
  'REMOVE_UPLOAD_ATTACHMENT',
  // downloads
  'DOWNLOAD_ATTACHMENT',
  'UPDATE_ATTACHMENT_DOWNLOAD_STATUS',
  'REMOVE_DOWNLOAD_ATTACHMENT',

  'NEW_CHANNEL_ACTIVITY',
  'REMOVE_MESSAGES',

  'ADD_SOCIAL_CHAT',
  'UPDATE_CHAT_NAME',
  'UPDATE_CONTEXT_CHAT_NAME',
  'UPDATE_CHANNEL',
  'UPDATE_CONTEXT_CHANNEL',
  'REMOVE_CHANNEL',
  'REMOVE_CONTEXT_CHANNEL',
  'REMOVE_SOCIAL_CHANNEL',
  'REMOVE_CHANNEL_MESSAGE',
  'REMOVE_CONTEXT',
  'REMOVE_CONTEXT_USER',

  'TOGGLE_BLOCKED_CHAT',
  'UPDATE_BLOCKED_STATUS',
  'UPDATE_CHAT',

  'COMPLETE_INBOX_TASK',
  'UPDATE_CHANNEL_INBOX_TASK_ID',

  // communities
  'NEW_JOIN_REQUEST',
  'JOIN_REQUEST_ACCEPTED',
  'JOIN_REQUEST_DECLINED',
  'NEW_POST',
  'NEW_POST_COMMENT',
  'NEW_COMMENT_REPLY',

  'NEW_COMMUNITY_INVITE',
  'COMMUNITY_INVITE_ACCEPT',
  'COMMUNITY_INVITE_DECLINE',

  'NEW_COMPLAINT',

  'LOGOUT',
];

export default createConsts('chatConnection', 'sync', ...supportedActions);



// WEBPACK FOOTER //
// ./src/redux/chatConnection/constants.js